import { dataAudioSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAudioSolid = /*#__PURE__*/createIcon(dataAudioSolid)
export default IconAudioSolid
